import { useEffect, useState } from 'react';

/**
 *
 * @type {import('.').UseScrollDirectionType}
 */
const useScrollDirection = ({ offset = 10, ref }) => {
  const [state, setState] = useState({
    top: false,
    bottom: false,
    left: false,
    right: false,
    scrollWidth: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollTop: 0,
    scrollLeft: 0,
  });
  useEffect(() => {
    const { current } = ref;
    if (!current) {
      return () => {};
    }
    const handleChange = () => {
      const { scrollLeft, scrollWidth, scrollHeight, scrollTop, clientWidth, clientHeight } = current;

      setState({
        top: scrollTop >= offset,
        bottom: scrollTop <= scrollHeight - clientHeight - offset,
        left: scrollLeft >= offset,
        right: scrollLeft <= scrollWidth - clientWidth - offset,
        scrollWidth,
        clientWidth,
        clientHeight,
        scrollTop,
        scrollLeft,
      });
    };

    const observer = new ResizeObserver(handleChange);
    observer.observe(current);

    const timeout = setTimeout(handleChange, 10);
    current.addEventListener('scroll', handleChange, { passive: true });
    window.addEventListener('resize', handleChange);
    return () => {
      clearTimeout(timeout);
      observer.disconnect();
      window.removeEventListener('resize', handleChange);
      current.removeEventListener('scroll', handleChange, { passive: true });
    };
  }, [ref, offset]);

  return state;
};

export default useScrollDirection;
